import "core-js/modules/es.array.concat";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import CardMoreButton from '@/components/CardMoreButton.vue';
import { trialStatus, meetingStatus } from '@/config/dic';

var SchedulingCard = /*#__PURE__*/function (_Vue) {
  _inherits(SchedulingCard, _Vue);

  var _super = _createSuper(SchedulingCard);

  function SchedulingCard() {
    var _this;

    _classCallCheck(this, SchedulingCard);

    _this = _super.apply(this, arguments);
    _this.todoIcon = [require('@/assets/icons/todo.svg')];
    return _this;
  }

  _createClass(SchedulingCard, [{
    key: "onAgainSchedule",
    value: function onAgainSchedule() {}
  }, {
    key: "onCancelScheduleSuccess",
    value: function onCancelScheduleSuccess() {}
  }, {
    key: "onDeleteCasePlanSuccess",
    value: function onDeleteCasePlanSuccess() {}
  }, {
    key: "onUploadEvidence",
    value: function onUploadEvidence() {
      this.$router.push("/index/uploadEvidence/".concat(this.caseId));
    }
  }, {
    key: "showNameMap",
    get: function get() {
      return this.$store.getters.showNameMap;
    }
  }, {
    key: "caseId",
    get: function get() {
      if (this.info.relationList && this.info.relationList.length) {
        return this.info.relationList[0].caseIndexCode;
      }

      return '';
    }
  }, {
    key: "userId",
    get: function get() {
      return this.$store.getters.userInfo.userId;
    } // 展示更多按钮的事件名称

  }, {
    key: "eventList",
    get: function get() {
      var eventList = ['caseDetail'];

      if (this.info.trialStatus === trialStatus.unTrial && this.info.meetingStatus === meetingStatus.unCreate) {
        eventList = eventList.concat(['editCase', 'delPlanCase', 'resetPlan', 'cancelPlan']);
      }

      return eventList;
    }
  }]);

  return SchedulingCard;
}(Vue);

__decorate([Prop({
  required: true
})], SchedulingCard.prototype, "info", void 0);

__decorate([Emit('onAgainSchedule')], SchedulingCard.prototype, "onAgainSchedule", null);

__decorate([Emit('onCancelScheduleSuccess')], SchedulingCard.prototype, "onCancelScheduleSuccess", null);

__decorate([Emit('onDeleteCasePlanSuccess')], SchedulingCard.prototype, "onDeleteCasePlanSuccess", null);

SchedulingCard = __decorate([Component({
  components: {
    CardMoreButton: CardMoreButton
  }
})], SchedulingCard);
export default SchedulingCard;